import { render, staticRenderFns } from "./dynamicTrainingColumns.vue?vue&type=template&id=505d1e96"
import script from "./dynamicTrainingColumns.vue?vue&type=script&lang=js"
export * from "./dynamicTrainingColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports